// extracted by mini-css-extract-plugin
export default {"summary-item-view":"SummaryItemView_summary-item-view__K2FfQ"};